<template>
  <Datepicker 
    :placeholder="'00/00/00'"
    :format="'dd/MM/yy'"

    v-model="date"
    @selected="value => handleChange(value)"
  ></Datepicker>
</template>
<script>
import Datepicker from 'vuejs-datepicker';
export default {
  components: {
    Datepicker
  },
  props: {
    defaultDate: {
      type: [String, Date, undefined],
      required: false,
    },
    id: {
      type: [String, Number],
      required: false
    },
  },
  data() {
    return {
      date: ''
    }
  },
  methods: {
    handleChange(value) {
      this.date = value;
      this.$emit('input', this.date, this.id);
    },
  },
  watch: {
    defaultDate(newDefaultDate, oldDefaultDate) {
      if(newDefaultDate!=undefined) {
        this.date = new Date(newDefaultDate);
      }
      else{
        this.date = this.date;
      }
    }
  },
}
</script>
<style>
.vdp-datepicker{
  width:40%;
}
.vdp-datepicker input{
  border: none!important;
  height: 35px;
  border-radius: 12px 12px 12px 0px;
  text-align: center;
  width: 100%;
  background: #e4f4f9;
  outline: none;
}
.vdp-datepicker__calendar{
  margin-top: 10px;
  width: 13.5em !important;
  box-shadow: 0 3px 6px #00000029;
  border: none !important;
}
.vdp-datepicker__calendar header span{
  height: 2.5em !important;
  line-height: 2.5em !important;
  font-size: 14px !important;
  font-weight: 300 !important;
  font-family: 'MyriadPro' !important;
  background-color: #0181A0!important;
  color: white!important;
}
.prev, .next, .day__month_btn {
    background-color: #0181A0!important;
    color: white!important;
}

.vdp-datepicker__calendar header .next:after {
    border-left: 10px solid #fff!important;
    margin-left: 5px;
}

.vdp-datepicker__calendar header .prev:after {
    border-right: 10px solid #fff!important;
    margin-left: -5px;
}

.vdp-datepicker__calendar header .up:not(.disabled):hover{
  background-color: #0181A0!important;
  color: white!important;
}
.vdp-datepicker__calendar .cell{
  font-size: 12px !important;
  font-weight: 500 !important;
  font-family: 'MyriadPro' !important;
  color: #1381a2!important;
  padding: 0.3em 0.6em !important;
  height: 30px !important;
  line-height: 1.9em !important;
}
.vdp-datepicker__calendar .cell.day-header{
  color: #454545!important;
}
.vdp-datepicker__calendar .cell.selected{
  color: white!important;
  border-radius: 25px;
}
.vdp-datepicker__calendar .prev {
  border-top-left-radius: 20px;
}
.vdp-datepicker__calendar .next {
  border-top-right-radius: 20px;
}
.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).day:hover {
  border-radius: 25px;
}
</style>